"use client";

import dynamic from "next/dynamic";
import { useClientOnly } from "@/hooks/useClientOnly";

interface TimelineItem {
  year: string;
  text: string;
}

interface OurStoryMobileWrapperProps {
  data: {
    tagline: string;
    title: string;
    description: string;
    timeline: TimelineItem[];
  };
}


const OurStoryMobile = dynamic(() => import("./OurStoryMobile"), {
  ssr: false,
});

export default function OurStoryMobileWrapper({
  data,
}: OurStoryMobileWrapperProps) {
  const hasMounted = useClientOnly();

  
  if (!hasMounted) {
    return null;
  }

  return <OurStoryMobile data={data} />;
}
